export const slugify = (str: string) => {
    if (!str.replace) {
        // it's not a string
        return str;
    }
    return str
        .replace(/\s+/g, "-")
        .replace(/[^a-zA-Z\- ]/g, "")
        .toLowerCase();
};
